module.exports = __webpack_public_path__ + "static/media/box_firebox.6c6491d5.svg";